export enum MediaType {
  DOCUMENT = <any>'DOCUMENT',
  IMAGE = <any> 'IMAGE',
  ZIP = <any> 'ZIP',
  VIDEO = <any> 'VIDEO',
  AUDIO = <any> 'AUDIO'
}
